import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyGirafeMode({ brand, today, Copy }: ModeRendererProps) {
  const idBase = React.useMemo(() => {
    try {
      const url = typeof window !== "undefined" ? new URL(window.location.href) : null;
      const param = url
        ? url.searchParams.get("id") || url.searchParams.get("uid") || url.searchParams.get("modeId") || url.searchParams.get("mode_id")
        : null;
      return param ? `girafe_${param}` : `girafe_${Math.random().toString(36).slice(2, 8)}`;
    } catch {
      return `girafe_${Math.random().toString(36).slice(2, 8)}`;
    }
  }, []);

  const spotId = `${idBase}_spot`;

  const defs = (
    <defs>
      <radialGradient id={spotId} cx="50%" cy="50%">
        <stop offset="0%" stopColor="#f6e7c1" stopOpacity={1} />
        <stop offset="100%" stopColor="#8b5a2b" stopOpacity={1} />
      </radialGradient>
    </defs>
  );

  const spots: React.ReactNode[] = [];
  // tall column of spots like giraffe coat
  for (let col = 0; col < 6; col++) {
    for (let row = 0; row < 18; row++) {
      const x = 120 + col * 100 + (row % 2) * 18;
      const y = 80 + row * 56;
      const rx = 34 + ((col + row) % 3) * 6;
      const ry = 28 + ((col + row) % 2) * 8;
      spots.push(
        <ellipse
          key={`spot-${col}-${row}`}
          cx={x}
          cy={y}
          rx={rx}
          ry={ry}
          fill={`url(#${spotId})`}
          opacity={0.85}
        />
      );
    }
  }

  return (
    <g>
      {defs}
      <rect width={794} height={1123} fill="#f3e0b8" />
      <g transform="translate(0,20)">{spots}</g>
      <g className="mode-copy" transform="translate(48, 840)" fill="#5a3b20" fontFamily="monospace">
        <text x={0} y={0} fontSize={18} fontWeight={700}>
          {Copy?.title}
        </text>
        <text x={0} y={22} fontSize={14}>
          {Copy?.subtitle}
        </text>
        <text x={0} y={44} fontSize={12} opacity={0.9}>
          {Copy?.date}
        </text>
      </g>
    </g>
  );
}

export default VasarelyGirafeMode;
